export default "__VITE_ASSET__474418e6__"